import { useCallback, useEffect, useRef, useState } from "react";
import { GetAllOrg, Org, DeleteOrg } from "../Api";
import { Alert, Box, Button, Grid, Modal, Snackbar } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import DataTable from "react-data-table-component";
import AddOrg from "./AddOrg";
import ConfirmationDialog from "./ConfirmationDialog";
import Spinner from "../Spinner";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store";

export default function OrganizationList() {
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.user);

  const parentRef = useRef(null);
  const [parentWidth, setParentWidth] = useState(0);
  const [updateModal, setUpdateModal] = useState<any>();
  const [selectedVersion, setSelectedVersion] = useState<Org>();

  const [openOrgModal, setOpenOrgModal] = useState<boolean>(false);
  const [organizations, setOrganizations] = useState<any>([]);
  const [deleteOrg, setDeleteOrg] = useState<string>();
  const [open, setOpen] = useState(false);
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error";
  }>({ open: false, message: "", severity: "success" });
  const [spinner, setSpinner] = useState(false);

  useEffect(() => {
    fetchData();
  }, [selectedVersion]);

  useEffect(() => {
    if (parentRef.current) {
      var parentCurrent: any = parentRef.current;
      setParentWidth(parentCurrent?.clientWidth);
    }
  }, [parentRef]);

  async function fetchData() {
    setSpinner(true);
    try {
      const org = await GetAllOrg();
      setOrganizations(org);
      // if (org) {
      //     setSnackbar({ open: true, message: "Organization", severity: "success" });
      // }
      setSpinner(false);
    } catch (error) {
      setSnackbar({ open: true, message: `${error}`, severity: "error" });
      setSpinner(false);
      console.log("Error:", error);
    }
  }

  const handleDeleteClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = async () => {
    // Perform the delete action here
    if (deleteOrg) {
      await DeleteOrg(deleteOrg);
      await fetchData();
    }
    setOpen(false);
  };

  if (!user) return <>loading...</>;
  const sesscol = [
    {
      name: "Name",
      selector: (row: any) => row?.name,
    },
    {
      name: "Description",
      selector: (row: any) => row?.description,
    },
    {
      name: "Location",
      selector: (row: any) => row?.location,
    },
    {
      name: "Total Flow",
      cell: (row: any) => {
        return (
          row?.files !== true && (
            <>
              <Button
                style={{ backgroundColor: "#bdbdbd" }}
                // style={{ textDecoration: "none" }}
                onClick={() => {
                  navigate(`/app/view/s/${row.id}`);
                }}
                // to={`/app/view/s/${row.id}`}
              >
                {row.files}
              </Button>
            </>
          )
        );
      },
    },

    {
      name: "Actions",
      cell: (row: Org) => {
        return (
          <>
            {user.role === "Admin" && (
              <IconButton edge="end" aria-label="delete">
                <DeleteIcon
                  color="error"
                  onClick={async () => {
                    //   await DeleteOrg(row.name);
                    //   await fetchData();
                    setDeleteOrg(row?.id);
                    handleDeleteClick();
                  }}
                />
              </IconButton>
            )}
            <Button
              onClick={() => {
                setSelectedVersion(row);
                setUpdateModal(true);
              }}
            >
              Update
            </Button>
          </>
        );
      },
    },
  ];

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <Box sx={{ p: 2 }}>
        <Spinner running={spinner} />
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
            gap: 2,
          }}
          flexDirection={"column"}
          ref={parentRef}
        >
          <Grid
            container
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <h3>All Organizations</h3>
            <div>
              <Button variant="contained" onClick={() => setOpenOrgModal(true)}>
                Create Organization
              </Button>
            </div>
          </Grid>
          <div
            style={{
              flex: 1,
              width: parentWidth,
            }}
          >
            {/* <DataTable
            columns={col}
            data={organizations ? organizations : []}
            pagination
            style={{ height: "70vh", width: "0vh !important" }}
          /> */}
            {/* new */}
            <DataTable
              columns={sesscol}
              data={organizations ? organizations : []}
              style={{ height: "70vh", width: "0vh !important" }}
            />
          </div>
          <Modal
            open={openOrgModal ? true : false}
            onClose={() => setOpenOrgModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <AddOrg setOpenOrgModal={setOpenOrgModal} fetchData={fetchData} />
          </Modal>
          <Modal
            open={updateModal}
            onClose={() => setUpdateModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <AddOrg
              setOpenOrgModal={setUpdateModal}
              updateData={selectedVersion}
              fetchData={fetchData}
            />
          </Modal>
        </Grid>
        <ConfirmationDialog
          open={open}
          handleClose={handleClose}
          handleConfirm={handleConfirm}
          title="Delete Confirmation"
          description="Are you sure you want to delete this Organization? This action cannot be undone."
        />
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          message={snackbar.message}
          action={
            <Button color="inherit" onClick={handleCloseSnackbar}>
              Close
            </Button>
          }
        >
          <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
}
